﻿import { ArrowLeft } from "lucide-react";
import { Link , useNavigate } from "react-router-dom";
import { toast } from "sonner";
import type { CreateEventRequest } from "@ticketnjoy/types";

import { DashboardPage } from "@/components/dashboard-page";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useCreateEventMutation } from "@/features/events/api";
import {
  EventForm,
  type CreateEventFormValues,
} from "@/features/events/event-form";
import { localInputToIso } from "@/features/events/date-helpers";

export function NewEventPage() {
  const navigate = useNavigate();
  const mutation = useCreateEventMutation();

  const onSubmit = async (values: CreateEventFormValues) => {
    const payload: CreateEventRequest = {
      title: values.title,
      description: values.description || null,
      coverImageUrl: values.coverImageUrl || null,
      slug: values.slug || null,
      venueName: values.venueName || null,
      venueAddress: values.venueAddress || null,
      venueCity: values.venueCity || null,
      latitude: values.latitude ?? null,
      longitude: values.longitude ?? null,
      startsAt: localInputToIso(values.startsAt)!,
      endsAt: localInputToIso(values.endsAt)!,
      defaultTaxRate: values.defaultTaxRate,
    };

    try {
      const evt = await mutation.mutateAsync(payload);
      toast.success("Taslak oluşturuldu. Şimdi bilet türlerini ekle.");
      navigate(`/events/${evt.slug}`);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Oluşturulamadı.");
    }
  };

  return (
    <DashboardPage>
      <div className="mb-6">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/events">
            <ArrowLeft className="mr-1 h-4 w-4" /> Etkinliklere dön
          </Link>
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Yeni Etkinlik</CardTitle>
          <CardDescription>
            Etkinlik taslak olarak oluşturulur. Bilet türlerini ekleyip en az bir mekan tanımladıktan
            sonra yayına alabilirsin.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <EventForm mode="create" onSubmit={onSubmit} isSubmitting={mutation.isPending} />
        </CardContent>
      </Card>
    </DashboardPage>
  );
}
